import { z } from 'zod'

import type {
  ArrivalsBoardDirection,
  ArrivalsBoardEntry,
  ArrivalsBoardLocation,
  ArrivalsBoardMode,
  ArrivalsBoardResponse,
  ArrivalsBoardStatus,
} from '@forto-dev/search-light-models'

export type { ArrivalsBoardEntry, ArrivalsBoardResponse }
export type TransportMode = ArrivalsBoardMode
export type BoardDirection = ArrivalsBoardDirection
export type BoardEntryStatus = ArrivalsBoardStatus
export type BoardLocation = ArrivalsBoardLocation

export const transportModeSchema = z.enum(['rail', 'air', 'sea'])

export const ARRIVALS_BOARD_LIMIT = 10

const windowHoursByMode: Record<TransportMode, number> = {
  air: 168,
  sea: 336,
  rail: 336,
}

export const windowHoursForMode = (mode: TransportMode): number => windowHoursByMode[mode]

export const resolveBoardEntryStatus = (entry: ArrivalsBoardEntry, now: Date = new Date()): BoardEntryStatus => {
  const hasHappened = entry.isActual && new Date(entry.scheduledAt).getTime() <= now.getTime()
  if (hasHappened) {
    return entry.direction === 'departure' ? 'departed' : 'arrived'
  }
  return entry.status
}
